import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import MortgageChoiceConsent from './MortgageChoiceConsent';

class MortgageChoicePrivacyPage extends Component {
  render() {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
        <Helmet>
          <title>Mortgage Choice Privacy Policy | LoanGateway</title>
          <meta name="description" content="Mortgage Choice Privacy Policy" />
          <link rel="stylesheet" href={process.env.PUBLIC_URL + `/css/style.css`} />
        </Helmet>
        
        <div className="py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            
            {/* Header */}
            <div className="text-center mb-12">
              <img 
                src={process.env.PUBLIC_URL + '/images/logos/dark_transparent.png'} 
                alt="LoanGateway" 
                className="mx-auto mb-8 h-20 w-auto"
              />
              <h1 className="text-4xl font-bold text-gray-900 mb-4">
                Mortgage Choice Privacy Policy
              </h1>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Your privacy and data protection are our top priorities. Please review our comprehensive privacy policy below.
              </p>
            </div>

            {/* Content */}
            <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
              <div className="p-8 lg:p-12">
                <MortgageChoiceConsent 
                  consented={false}
                  onConsentChange={() => {}}
                  hideCheckbox={true}
                />
              </div>
            </div>

            {/* Footer */}
            <div className="text-center mt-12">
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <p className="text-sm text-gray-600 mb-4">
                  For questions about this privacy policy, please contact us at:
                </p>
                <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-6 text-sm text-gray-700">
                  <span className="flex items-center">
                    <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"/>
                      <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"/>
                    </svg>
                    customerservice@mortgagechoice.com.au
                  </span>
                  <span className="flex items-center">
                    <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                    </svg>
                    511 Church Street, Richmond VIC 3121
                  </span>
                  <span className="flex items-center">
                    <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                      <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
                    </svg>
                    02 8907 0444
                  </span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default MortgageChoicePrivacyPage; 